// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"491":"c8331a0a","999":"18489a48"}[chunkId] + ".chunk.css";
};